"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTable = exports.orderAndSortRows = exports.calculateColumnStyles = exports.createColumnSortSetter = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var objectUtilities_1 = require("../../../util/objectUtilities");
var Pagination_logic_1 = require("../Pagination/Pagination.logic");
var Pagination_static_1 = require("../Pagination/Pagination.static");
var Table_static_1 = require("./Table.static");
var Table_style_1 = __importDefault(require("./Table.style"));
function createColumnSortSetter(setSortState, columnSortKey, currentSortKey, currentSortOrder) {
    return function () {
        var nextSortOrder = (function () {
            if (columnSortKey !== currentSortKey || !currentSortOrder) {
                return Table_static_1.SortOrder.ASC;
            }
            switch (currentSortOrder) {
                case Table_static_1.SortOrder.None:
                    return Table_static_1.SortOrder.ASC;
                case Table_static_1.SortOrder.ASC:
                    return Table_static_1.SortOrder.DESC;
                case Table_static_1.SortOrder.DESC:
                    return Table_static_1.SortOrder.None;
                default:
                    return (0, objectUtilities_1.exhaustivenessCheck)(currentSortOrder);
            }
        })();
        setSortState({ currentSortOrder: nextSortOrder, currentSortKey: columnSortKey || null });
    };
}
exports.createColumnSortSetter = createColumnSortSetter;
function calculateColumnStyles(_a, columnsCount) {
    var minWidth = _a.minWidth, _b = _a.gridColumnSpace, gridColumnSpace = _b === void 0 ? 1 : _b;
    return {
        minWidth: minWidth,
        width: "".concat((gridColumnSpace / columnsCount) * 100, "%"),
    };
}
exports.calculateColumnStyles = calculateColumnStyles;
function orderAndSortRows(rows, sortKey, sortOrder, groupByKey) {
    if (sortOrder === void 0) { sortOrder = Table_static_1.SortOrder.None; }
    if (groupByKey) {
        var groupedRows = (0, lodash_1.groupBy)((0, lodash_1.sortBy)(rows, function (row) { var _a, _b; return (_b = (_a = row.sortValues) === null || _a === void 0 ? void 0 : _a[groupByKey]) !== null && _b !== void 0 ? _b : ''; }), function (row) { var _a, _b; return (_b = (_a = row.sortValues) === null || _a === void 0 ? void 0 : _a[groupByKey]) !== null && _b !== void 0 ? _b : ''; });
        return (0, lodash_1.flatMap)(groupedRows, function (rows) { return sortRows(rows, sortKey, sortOrder); });
    }
    return sortRows(rows, sortKey, sortOrder);
}
exports.orderAndSortRows = orderAndSortRows;
function sortRows(rows, sortKey, sortOrder) {
    if (sortOrder === void 0) { sortOrder = Table_static_1.SortOrder.None; }
    if (sortKey === null || sortOrder === Table_static_1.SortOrder.None) {
        return rows;
    }
    var order = sortOrder === Table_static_1.SortOrder.ASC ? 'asc' : 'desc';
    return (0, lodash_1.orderBy)(rows, function (row) { var _a, _b; return (_b = (_a = row.sortValues) === null || _a === void 0 ? void 0 : _a[sortKey]) !== null && _b !== void 0 ? _b : ''; }, order);
}
function buildCells(template, inputContent, setSortState, currentSortKey, currentSortOrder) {
    var columnsCount = (0, lodash_1.sumBy)(template, function (_a) {
        var gridColumnSpace = _a.gridColumnSpace;
        return gridColumnSpace !== null && gridColumnSpace !== void 0 ? gridColumnSpace : 1;
    });
    return template.map(function (column, index) { return ({
        colSpan: column.colSpan,
        style: calculateColumnStyles(column, columnsCount),
        content: inputContent[index],
        onSortClick: column.sortKey
            ? createColumnSortSetter(setSortState, column.sortKey, currentSortKey, currentSortOrder)
            : undefined,
        sortOrder: column.sortKey === currentSortKey && currentSortOrder ? currentSortOrder : Table_static_1.SortOrder.None,
        align: column.align || (index ? 'center' : 'left'),
    }); });
}
function useTable(_a) {
    var columnsTemplate = _a.columnsTemplate, groupBy = _a.groupBy, mountWithRowKey = _a.mountWithRowKey, noResults = _a.noResults, pageChangeScrollCorrection = _a.pageChangeScrollCorrection, rows = _a.rows, rowsPerPage = _a.rowsPerPage, sortBy = _a.sortBy, sortOrder = _a.sortOrder;
    var _b = __read((0, react_1.useState)({
        currentSortOrder: Table_static_1.SortOrder.None,
        currentSortKey: null,
    }), 2), sortState = _b[0], setSortState = _b[1];
    var currentSortKey = sortState.currentSortKey, currentSortOrder = sortState.currentSortOrder;
    var headerBuilt = (0, react_1.useMemo)(function () {
        return buildCells(columnsTemplate, columnsTemplate.map(function (template) { return template.header; }), setSortState, currentSortKey, currentSortOrder);
    }, [columnsTemplate, currentSortKey, currentSortOrder]);
    var sortedRows = (0, react_1.useMemo)(function () { return orderAndSortRows(rows, currentSortKey, currentSortOrder, groupBy); }, [currentSortKey, currentSortOrder, rows, groupBy]);
    var _c = (0, Pagination_logic_1.usePagination)({ items: sortedRows, itemsPerPage: rowsPerPage, pageChangeScrollCorrection: pageChangeScrollCorrection }), containerRef = _c.containerRef, dispatchPagination = _c.dispatchPagination, goToFirstPage = _c.goToFirstPage, goToLastPage = _c.goToLastPage, goToNextPage = _c.goToNextPage, goToPreviousPage = _c.goToPreviousPage, isOnFirstPage = _c.isOnFirstPage, isOnLastPage = _c.isOnLastPage, itemsOnCurrentPage = _c.itemsOnCurrentPage, itemsOnPageInfo = _c.itemsOnPageInfo;
    var previousMountWithRowKey = (0, react_1.useRef)(undefined);
    (0, react_1.useEffect)(function () {
        if (mountWithRowKey !== previousMountWithRowKey.current) {
            previousMountWithRowKey.current = mountWithRowKey;
            var rowNumber = sortedRows.findIndex(function (_a) {
                var rowKey = _a.rowKey;
                return rowKey === mountWithRowKey;
            }) + 1;
            if (!rowNumber) {
                return;
            }
            dispatchPagination({
                type: Pagination_static_1.PaginationAction.GoToSpecificPage,
                payload: Math.ceil(rowNumber / rowsPerPage),
                skipScroll: true,
            });
        }
    }, [dispatchPagination, mountWithRowKey, rowsPerPage, sortedRows]);
    var rowsBuilt = (0, react_1.useMemo)(function () {
        return itemsOnCurrentPage.map(function (_a) {
            var content = _a.content, adjustedColumnTemplate = _a.columnsTemplate, onClick = _a.onClick, rowKey = _a.rowKey, state = _a.state;
            return ({
                cells: buildCells(adjustedColumnTemplate || columnsTemplate, content, setSortState, currentSortKey, currentSortOrder),
                onClick: onClick,
                rowKey: rowKey,
                state: state,
            });
        });
    }, [columnsTemplate, currentSortKey, currentSortOrder, itemsOnCurrentPage]);
    (0, react_1.useEffect)(function () {
        if (!sortBy || !(0, lodash_1.some)(columnsTemplate, ['sortKey', sortBy])) {
            return;
        }
        setSortState({
            currentSortOrder: sortOrder || Table_static_1.SortOrder.ASC,
            currentSortKey: sortBy,
        });
    }, [columnsTemplate, sortBy, sortOrder]);
    return {
        headerBuilt: headerBuilt,
        rowsBuilt: rowsBuilt,
        classes: (0, Table_style_1.default)(),
        containerRef: containerRef,
        goToFirstPage: goToFirstPage,
        goToLastPage: goToLastPage,
        goToNextPage: goToNextPage,
        goToPreviousPage: goToPreviousPage,
        isOnFirstPage: isOnFirstPage,
        isOnLastPage: isOnLastPage,
        itemsOnPageInfo: itemsOnPageInfo,
        noResultsWidth: noResults ? (0, lodash_1.sumBy)(columnsTemplate, function (column) { return column.colSpan || 1; }) : undefined,
    };
}
exports.useTable = useTable;
